/**
 * 系统模块（OFBiz 新接口）
 * ------------------------------------------------------------------
 * 对应后端：POST /itoss/control/json/system/*
 *
 * 迁移自前端原接口（rest_client.js / setting_action.js）：
 *   getSelfCheckData  -> /rest/system/selfcheck
 *   getLicenseInfoData -> /rest/system/license/info
 *   getServerCurrentTime -> /rest/other/currenttime
 *   getSchedulerData  -> /rest/.../scheduler
 */
import { ofbiz } from './http';

/**
 * 系统自检（替代旧 /rest/system/selfcheck）
 *
 * 返回 DB/监测器/告警/采集任务/JVM 状态 + 综合 status。
 * 注意：旧接口返回 { CategoryProps: [...] }，本接口返回结构不同，
 * 由 setting_action.getSelfCheckData 做格式适配。
 * @returns {Promise<object>}
 */
export function getSelfCheck() {
  return ofbiz.post('system/selfcheck');
}

/**
 * License 信息（替代旧 /rest/system/license/info）
 * @returns {Promise<object>}
 */
export function getLicenseInfo() {
  return ofbiz.post('system/licenseInfo');
}

/**
 * 服务器当前时间（替代旧 /rest/other/currenttime，用于校时）
 * @returns {Promise<object>} 通常含 currentTime / timestamp
 */
export function getCurrentTime() {
  return ofbiz.post('system/currentTime');
}

/**
 * 调度概览（替代旧 /rest/.../scheduler）
 * @returns {Promise<object>}
 */
export function getScheduler() {
  return ofbiz.post('system/scheduler');
}
